import { createReducer } from 'redux-act';
import { TLegacyErrors } from '@alycecom/services';

import { loadStatusesRequest, loadStatusesSuccess, loadStatusesFail, updateStatuses } from './statuses.actions';
import { IStatuses } from './statuses.types';

export interface IStatusesState {
  isLoaded: boolean;
  isLoading: boolean;
  statuses: IStatuses;
  errors: TLegacyErrors;
}

export const initialState: IStatusesState = {
  isLoaded: false,
  isLoading: false,
  statuses: {
    activate: false,
    meeting: false,
    address: false,
    actions: false,
    exchange: false,
    preview: false,
    draft: false,
    hasIntegration: false,
    international: false,
    declaredData: false,
    declaredDataMinimumProductQuantity: 0,
    hasCustomMarketplace: false,
    oneTimeCodeVerification: false,
    maxVerificationAttemptReached: false,
    whiteLabeling: false,
  },
  errors: {},
};

const reducer = createReducer<IStatusesState>({}, initialState);

reducer
  .on(loadStatusesRequest, state => ({
    ...state,
    isLoading: true,
  }))
  .on(loadStatusesSuccess, (state, payload) => ({
    ...state,
    statuses: payload,
    isLoading: false,
    isLoaded: true,
  }))
  .on(loadStatusesFail, (state, payload) => ({
    ...state,
    isLoading: false,
    errors: payload,
  }))
  .on(updateStatuses, (state, payload) => ({
    ...state,
    statuses: {
      ...state.statuses,
      ...payload,
    },
  }));

export default reducer;
